export default __webpack_public_path__ + "locales/pt/Errors.json?hash=43a7790bd34f04415d2ddb8fd5103f60";